import config from '../../config';
import { request } from '../../libraries/request'

const getAll = (params = {}, token) => {
  console.log('SERVICES::RECYCLING::get', params, token);
  if (params && params.page_num && config.QUERIES_PAGE_SIZE) {
    params.page_size = config.QUERIES_PAGE_SIZE;
  }
  if (!params.order_by) { 
    /* params.order_by = 'products__updated_at'; */
    params.order_direction = 'DESC';
  }
  if (!params.enabled) {
    params.enabled = 1
  }
  params.type = config.TYPES.INITIATIVES.RECYCLING;

  return request({
    url: config.BASE_API_URL + config.API.INITIATIVES,
    accessToken: token,
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }
    return response;
  })
}

const save = (params, token) => {
  console.log('SERVICES::RECYCLING::save', params, token);
  return request({
    url: config.BASE_API_URL + config.API.INITIATIVES,
    accessToken: token,
    method: 'POST',
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const update = (params, token) => {
  console.log('SERVICES::RECYCLING::update', params, token);
  return request({
    url: config.BASE_API_URL + config.API.INITIATIVE.replace('{id}', params.id),
    accessToken: token,
    method: 'PATCH',
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

const get = (params, token) => {
  console.log('SERVICES::RECYCLING::get', params.id, token);
  return request({
    url: config.BASE_API_URL + config.API.INITIATIVE.replace('{id}', params.id),
    accessToken: token,
    // data: {},
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })

}

const del = (params, token) => {
  console.log('SERVICES::RECYCLING::remove', params.id, token);
  return request({
    url: config.BASE_API_URL + config.API.INITIATIVE.replace('{id}', params.id),
    accessToken: token,
    method: 'DELETE',
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })
}

export default {
  getAll,
  save,
  get,
  del,
  update,
};